import React, { useEffect, useState } from "react";
import AdminSidebar from "../../components/AdminSidebar";
import { VENDOR_CATEGORIES } from "../../constants/vendorCategories";
import "./admin.css";

export default function AdminVendorDirectory() {
  const [entries, setEntries] = useState([]);
  const [error, setError] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");

  const API = process.env.REACT_APP_API_URL;
  const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  const load = async () => {
    try {
      const res = await fetch(`${API}/api/vendors`, { headers: authHeader });
      if (!res.ok) {
        setError("Failed to load vendor directory");
        return;
      }
      setEntries(await res.json());
    } catch (err) {
      setError("Server error while loading directory");
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteEntry = async (id) => {
    await fetch(`${API}/api/vendors/${id}`, { method: "DELETE", headers: authHeader });
    load();
  };

  const filtered = activeCategory === "All" ? entries : entries.filter((e) => e.category === activeCategory);

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>Vendor Directory</h1>
        <p className="admin-sub">Moderate resident-contributed vendor and service listings</p>

        {error && <p className="admin-error">{error}</p>}

        <div className="vendors-tabs" style={{ marginBottom: 20 }}>
          <button
            className={activeCategory === "All" ? "vendors-tab active" : "vendors-tab"}
            onClick={() => setActiveCategory("All")}
          >
            All
          </button>
          {VENDOR_CATEGORIES.map((c) => (
            <button
              key={c}
              className={activeCategory === c ? "vendors-tab active" : "vendors-tab"}
              onClick={() => setActiveCategory(c)}
            >
              {c}
            </button>
          ))}
        </div>

        <div className="admin-table">
          <div className="admin-header admin-row-wide">
            <span>Service</span>
            <span>Vendor / Contact</span>
            <span>Phone</span>
            <span>Category</span>
            <span>Actions</span>
          </div>

          {filtered.map((e) => (
            <div className="admin-row admin-row-wide" key={e.id}>
              <span>{e.serviceName}</span>
              <span>{e.vendorName || e.contactPerson || "—"}</span>
              <span>{e.phone}</span>
              <span>{e.category}</span>
              <div className="admin-actions">
                <button className="reject-btn" onClick={() => deleteEntry(e.id)}>Delete</button>
              </div>
            </div>
          ))}

          {filtered.length === 0 && !error && (
            <p className="admin-empty">No entries in this category</p>
          )}
        </div>
      </div>
    </div>
  );
}